<template>
  <div
    :class="`tag-container tw-cursor-default tw-flex tw-items-center tw-w-fit tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-font-medium tw-rounded ${
      props.color
    } ${props.expand ? 'contract' : ''}`"
  >
    <span
      v-if="prefilled"
      class="tw-rounded tw-max-w-fit tw-overflow-hidden tw-truncate"
      >{{
        props.numberQuestion +
        " " +
        getComponentUiText(
          "app-component-assessments-question-not-applicable-tag-1",
        )
      }}</span
    >&nbsp;
    <span class="expand-text tw-font-normal">{{ props.text }}</span>
  </div>
</template>

<script lang="ts" setup>
import { IAssessmentNotApplicableTagColor } from "@/interfaces/assessments/IAssessmentDetails";
import { getComponentUiText } from "@/utils/utilities";
import { PropType, defineProps } from "vue";

const props = defineProps({
  color: {
    type: String as PropType<IAssessmentNotApplicableTagColor>,
    required: true,
  },
  numberQuestion: { type: String, default: "", required: true },
  text: { type: String, default: "", required: false },
  expand: { type: Boolean, default: false, required: true },
  prefilled: { type: Boolean, default: true },
});
</script>

<style scoped lang="scss">
.tag-container {
  height: 20px;
  line-height: 130%;
  background-color: #dbdbdb;
  color: #2a2a2c;
  opacity: 1 !important;

  .expand-text {
    display: none;
  }

  &.contract,
  &:hover {
    .expand-text {
      display: block;
    }
  }

  &.grey {
    color: #ada8a8;
    background-color: #dbdbdb;
  }
}
</style>
